<template>
  <svg
    viewBox="0 0 1024 1024"
    :class="iconClass"
    :fill="color"
    @click="handleClick"
  >
    <path
      d="M662 170h148v86h-596v-86h148l44-42h212zM360 506l92 92-90 90 60 60 90-90 90 90 60-60-90-90 90-92-60-60-90 92-90-92zM256 810v-512h512v512q0 34-26 60t-60 26h-340q-34 0-60-26t-26-60z"
    ></path>
  </svg>
</template>
<script>
/**
 * @description Componente que exibe o icone deletar
 */
export default {
  name: "DeleteIcon",
  props: {
    color: {
      type: String,
      default: "white",
    },
    size: {
      type: String,
      default: "1.5rem",
    },
  },
  computed: {
    iconColor() {
      switch (this.color) {
        case "white":
          return "delete-icon";
        case "black":
          return "delete-icon-black";
        default:
          return "delete-icon";
      }
    },
    iconSize() {
      switch (this.size) {
        case "small":
          return "small";
        case "medium":
          return "medium";
        case "large":
          return "large";
        default:
          return "medium";
      }
    },
    iconClass() {
      return this.iconColor + " " + this.iconSize;
    },
  },
  methods: {
    handleClick() {
      this.$emit("action");
    },
  },
};
</script>
<style scoped>
.delete-icon {
  width: 1.5rem;
  height: 1.5rem;
}

.delete-icon:hover {
  fill: var(--dl-color-gray-white);
  cursor: pointer;
}

.delete-icon-black {
  width: 1.5rem;
  height: 1.5rem;
}

.delete-icon-black:hover {
  fill: var(--dl-color-gray-700);
  cursor: pointer;
}

.small {
  width: 1rem;
  height: 1rem;
}

.medium {
  width: 1.25rem;
  height: 1.25rem;
}

.large {
  width: 2rem;
  height: 2rem;
}
</style>
